
const AppConfig = {
    appVersion: '1.2.16',
    oauth: true
};

export const APP_CONFIG = AppConfig;
